import { useEffect, useRef } from "react";

const DrawingManager = ({ childrenCommon, edit, hideNodes }) => {
    const drawingManager = useRef(null);

    useEffect(() => {
        const { drawedElements, gmap } = childrenCommon;
        if (!edit) {
            if (drawingManager.current) {
                drawingManager.current.setOptions({ drawingMode: null });
            }
            return;
        }

        const marker = window.google.maps.drawing.OverlayType.MARKER;
        const polygon = window.google.maps.drawing.OverlayType.POLYGON;
        const rectangle = window.google.maps.drawing.OverlayType.RECTANGLE;
        const circle = window.google.maps.drawing.OverlayType.CIRCLE;

        const drawingControlOptions = { drawingModes: hideNodes ? [
            polygon, rectangle, circle
        ] : [ marker ] };

        if (!drawingManager.current) {
            drawingManager.current = new window.google.maps.drawing.DrawingManager({
                map: gmap,
                drawingControlOptions,
                markerOptions: { draggable: true },
                polygonOptions: { editable: true, strokeColor: "green", fillColor: "green", zIndex: 3 },
                rectangleOptions: { editable: true, strokeColor: "green", fillColor: "green", zIndex: 3 },
                circleOptions: { editable: true, strokeColor: "green", fillColor: "green", zIndex: 3 },
            });

            window.google.maps.event.addListener(drawingManager.current, "overlaycomplete", function(e) {
                drawedElements.current.length && drawedElements.current[0].setMap(null);
                drawedElements.current[0] = e.overlay;


                window.google.maps.event.addListener(e.overlay, "click", (event) => {
                    const { t, openInfoWindow, closeInfoWindow } = childrenCommon;
                    closeInfoWindow();
                    openInfoWindow(
                        gmap,
                        `<button type="button" class="btn btn-link" id="clickListener">${t("maps.delete")}</button>`,
                        event.latLng,
                        () => {
                            e.overlay.setMap(null);
                            const index = drawedElements.current.indexOf(e.overlay);
                            if (index > -1) {
                                drawedElements.current.splice(index, 1);
                            }
                            closeInfoWindow();
                        }
                    );
                }, { passive: true });
            });
        } else {
            drawingManager.current.setOptions({ drawingControlOptions });
            drawingManager.current.setMap(gmap);
        }

        return () => {
            if (drawingManager.current) {
                drawingManager.current.setMap(null);
            }
            if (drawedElements.current) {
                const elToDelete = drawedElements.current.splice(0, drawedElements.current.length);
                elToDelete.forEach((element) => element.setMap(null));
            }
        };
    }, [childrenCommon, edit, hideNodes]);

    return null;
};

export { DrawingManager };
